const _ = require('lodash')
const Modal = require('client/components/modal')

const ALERT_BUTTONS = [
  { label: 'OK', primary: true }
]
const CONFIRM_BUTTONS = [
  { label: 'Yes', value: true, primary: true },
  { label: 'No', value: false }
]

function normalizeOptions(options) {
  if (_.isString(options)) {
    return { subheading: options }
  }
  if (_.isError(options)) {
    return _.defaults({
      heading: options.friendlyHeading,
      subheading: options.friendlyMessage
    }, {
      heading: 'Sorry.',
      subheading: 'Something went wrong. Try again.'
    })
  }
  return options
}

function normalizeButtonOption(buttonOption) {
  if (_.isString(buttonOption)) {
    buttonOption = { label: buttonOption }
  }
  if (_.isBoolean(buttonOption.value)) {
    buttonOption.value = String(buttonOption.value)
    buttonOption.valueType = 'boolean'
  }
  return buttonOption
}

function normalizeButtonValue($button) {
  const value = $button.attr('data-value')
  const valueType = $button.attr('data-value-type')
  if (valueType === 'boolean') {
    return value !== 'false'
  }
  return value
}

module.exports = class ConfirmModal extends Modal {
  // Convenience helpers
  static alert(options) {
    options = _.defaults(normalizeOptions(options), {
      buttons: ALERT_BUTTONS
    })
    return ConfirmModal.promise(options)
  }

  static confirm(options) {
    options = normalizeOptions(options)
    return ConfirmModal.promise(options)
  }

  constructor(options) {
    options = _.defaults(options, {
      modalTemplate: require('*views/modals/confirm'),
      modalClassName: 'confirm-modal',
      modalHasHeader: false,
      buttons: CONFIRM_BUTTONS,
      closeOnBackdropClick: false
    })
    options.buttons = _.map(options.buttons, normalizeButtonOption)
    super(options)
  }

  didRender() {
    if (this.options.closeOnBackdropClick) {
      this.registerDefaultModalEventListeners()
    }
    this.$el.on('click', '.confirm-modal__button', event => {
      const $button = $(event.target)
      this.resolve(normalizeButtonValue($button))
    })
  }
}
